// extracted by mini-css-extract-plugin
export var label = "_e2-5";
export var slideContainer = "_e2-0";
export var slider = "_e2-1";
export var sliderLg = "_e2-4";
export var sliderMd = "_e2-3";
export var sliderSm = "_e2-2";